// extracted by mini-css-extract-plugin
export default {"webcam-container":"CameraScreen_webcam-container__dZZB0","webcam":"CameraScreen_webcam__i8Y78","camera-screen-container":"CameraScreen_camera-screen-container__l7fpm"};